import { render, staticRenderFns } from "./PortfolioCardList.vue?vue&type=template&id=02843c96&scoped=true&"
import script from "./PortfolioCardList.vue?vue&type=script&lang=js&"
export * from "./PortfolioCardList.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCardList.vue?vue&type=style&index=0&id=02843c96&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02843c96",
  null
  
)

export default component.exports